module.exports = __webpack_public_path__ + "img/left-arm_active.e9ed02aa.png";